// extracted by mini-css-extract-plugin
export default {"list":"styles_list__pWLp8","row":"styles_row__zSIip","cell":"styles_cell__d5c6X","header":"styles_header__5Cztf","headerCell":"styles_headerCell__OvOQs"};